import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  courses: {
    data: [],
    total: 0,
    filters: {
      search: "",
      skip: 0,
      take: 10,
      page: 0,
      company_id: null,
    },
  },
  courseDetails: {},
};

const seekerCoursesSlice = createSlice({
  name: "seekerCourses",
  initialState,
  reducers: {
    clearCourses: (state) => {
      state.courses = initialState.courses;
    },

    setCoursesFilters: (state, { payload }) => {
      state.courses.filters = {
        ...state.courses.filters,
        ...payload,
      };
    },

    refreshAndSetCourses: (state, { payload }) => {
      if (payload) {
        state.courses.data = payload.data;
        state.courses.total = payload.total;
      }
    },
    
    resetCoursesFilters: (state) => {
      state.courses.filters = initialState.courses.filters;
    },
    
    mergeCourses: (state, { payload }) => {
      state.courses.data = [...state.courses.data, ...payload.data];
      state.courses.total = payload.total;
    },

    setCourseDetails: (state, action) => {
      state.courseDetails = action.payload;
    },
  },
});

export const {
  refreshAndSetCourses,
  mergeCourses,
  clearCourses,
  setCourseDetails,
  setCoursesFilters,
  resetCoursesFilters,
} = seekerCoursesSlice.actions;

export default seekerCoursesSlice.reducer; 